export default {
    state: {
      start_date: null,
      end_date: null
    },
}